import { Text, Flex } from '@pancakeswap/uikit'
import styled from 'styled-components'

export const NowText = styled(Text)`
  font-size: 28px;
  font-weight: 500;
  line-height: 36px;
  text-align: center;
`

export const FillerFlex = styled(Flex)`
  flex: 0;
  @media (min-width: 1000px) {
    flex: 1.5;
  }
`
